import { computed, Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class BreadcrumbState {
  private _breadcrumbs = signal<MenuItem[]>([]);
  readonly breadcrumbs = this._breadcrumbs.asReadonly();

  private _currentPage = signal<string | null>(null);
  readonly currentPage = computed(() => {
    const items = this._breadcrumbs();
    if (!items.length) return null;
    return this._currentPage();
  });

  setBreadcrumbs(items: MenuItem[]): void {
    this._breadcrumbs.set(items);
  }

  clear(): void {
    this._breadcrumbs.set([]);
  }

  setCurrentPage(page: string | null): void {
    this._currentPage.set(page);
  }
}
